import React from 'react';
import { connect } from 'react-redux';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import DictionaryFieldTools from './DictionaryFieldTools';
import DictionaryFieldCardItemExtra from '../components/DictionaryFieldCardItemExtra';
import { showDictionaryField } from '../../dictionaries/actions';

const DictionaryFieldCardItem = ({
  canEdit,
  category,
  code,
  dictionaryUUID,
  field,
  isEditing,
  lookups,
  show,
  template,
  upward,
}) => (
  <CardItem className="aridhia-dictionary-list-item">
    <NameDescriptionCard
      description={field.description}
      href={isEditing ? undefined : '#'}
      meta={field.label}
      name={field.name}
      onClick={isEditing ? undefined : () => show(category, code, field.uuid, field.constraints, canEdit)}
    >
      {canEdit && (
      <DictionaryFieldTools
        code={code}
        category={category}
        dictionaryUUID={dictionaryUUID}
        fieldUUID={field.uuid}
        upward={upward}
        template={template}
      />
      )}
    </NameDescriptionCard>
    <DictionaryFieldCardItemExtra type={field.type} constraint={field.constraints} lookups={lookups} />
  </CardItem>
);

const mapDispatchToProps = {
  show: showDictionaryField,
};

export default connect(null, mapDispatchToProps)(DictionaryFieldCardItem);
